<template lang="pug">
    div.modal-container
        component(v-for='level in modalLevels' :key='level.level'
                v-if='level.active' v-bind='level.data' :hidden='level.hidden'
                :is="level.component" :data="level.data" :level="level.level" ref="modal")
</template>

<script>
import eventBus from '../../lib/event-bus'
import events from '../../lib/events'

export default {
    name: 'modal-container',

    data() {
        return {
            modalLevels: [],
        }
    },

    methods: {
        getOrCreateModalLevel(level) {
            const r = this.modalLevels.find(ml => ml.level == level)

            if (r) {
                return r
            }

            const modalLevel = {
                level,
                active: false,
                hidden: false,
            }
            this.modalLevels.push(modalLevel)

            return modalLevel
        },

        openLevel(modalLevel) {
            modalLevel.active = true

            this.modalLevels.filter(ml => ml.level > modalLevel.level).forEach(ml => {
                ml.active = false
            })
        },
        close(level) {
            this.modalLevels
                .filter(ml => level === null || level === undefined || ml.level >= level)
                .forEach(ml => ml.active = false)
        },
    },

    created() {
        eventBus.$on(events.OPEN_MODAL, (modal, data) => {
            return new Promise(resolve => {
                if (typeof(modal) == 'string') {
                    modal = {
                        component: modal,
                        level: 1,
                    }
                }

                const modalLevel = this.getOrCreateModalLevel(modal.level)

                if (modalLevel.hidden) {
                    modalLevel.hidden = false
                    modalLevel.active = false
                }

                this.$nextTick(() => {
                    modalLevel.component = modal.component
                    modalLevel.data = data

                    this.openLevel(modalLevel)

                    this.$nextTick(() => {
                        const modalComponent = this.$refs.modal[this.modalLevels.filter(l => l.active).findIndex(l => l.level == modalLevel.level)]
                        resolve({
                            modalComponent,
                        })
                    })
                })
            })
        })
        eventBus.$on(events.CLOSE_MODAL, level => {
            this.close(level)
        })

        eventBus.$on(events.HIDE_MODAL, () => {
            this.modalLevels.forEach(m => m.hidden = true)
        })
        eventBus.$on(events.SHOW_MODAL, () => {
            this.modalLevels.forEach(m => m.hidden = false)
        })
    },
}
</script>
